import { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';

export function WerbungPage() {
  const [selectedCategory, setSelectedCategory] = useState('alle');

  const categories = [
    { id: 'alle', name: 'Alle Produkte' },
    { id: 'digitaldruck', name: 'Digitaldruck' },
    { id: 'display', name: 'Display Produkte' },
    { id: 'schilder', name: 'Schilder' }
  ];

  const products = [
    {
      id: 1,
      category: 'digitaldruck',
      name: 'Vinyl-Druck',
      description: 'Hochwertige Vinyl-Drucke für Innen- und Außenwerbung. Langlebig, wetterfest und in brillanten Farben.',
      features: ['Wetterfest', 'UV-beständig', 'Langlebig', 'Brillante Farben'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/26fed435c61cda74877fb48b43df601e.jpeg',
      sizes: ['50 x 70cm', '100 x 150cm', '200 x 300cm', 'Sonderformate']
    },
    {
      id: 2,
      category: 'display',
      name: 'Faltbare Stoffwand',
      description: 'Elegante faltbare Stoffwände für Messen und Präsentationen. Schneller Auf- und Abbau.',
      features: ['Faltbar', 'Leicht transportierbar', 'Stoffbespannung', 'Wiederverwendbar'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/ff3a3373e0bff955ad4d801ff1c35574.jpeg',
      sizes: ['2m x 2m', '3m x 2m', '4m x 2m']
    },
    {
      id: 3,
      category: 'display',
      name: 'Spinnenstand',
      description: 'Flexibler Spinnenstand für vielseitige Werbepräsentationen. Stabil und professionell.',
      features: ['Flexibel einsetzbar', 'Stabiles Gestell', 'Schneller Aufbau', 'Kompakt verstaubar'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/0af6fdd7cdf8e6701304fc516be5180d.jpeg',
      sizes: ['1,5m x 1,5m', '2m x 2m', '3m x 3m']
    },
    {
      id: 4,
      category: 'display',
      name: 'Roll-Up',
      description: 'Klassische Roll-Up Banner für Messen, Events und Präsentationen. Der Werbeklassiker.',
      features: ['Leicht transportierbar', 'Schneller Aufbau', 'Inkl. Tragetasche', 'Hochwertige Druckqualität'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/234a2618e0a64580f067054eb58ba790.jpeg',
      sizes: ['85 x 200cm', '100 x 200cm', '120 x 200cm']
    },
    {
      id: 5,
      category: 'display',
      name: 'X-Banner',
      description: 'Kostengünstige X-Banner für effektive Werbung. Ideal für temporäre Aktionen.',
      features: ['Kostengünstig', 'Leicht', 'Einfache Montage', 'Austauschbare Grafik'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/bbf862f021e9cc2b27b27ac64021b64a.jpeg',
      sizes: ['60 x 160cm', '80 x 180cm', '80 x 200cm']
    },
    {
      id: 6,
      category: 'schilder',
      name: 'Runde Laternenschild',
      description: 'Klassische runde Laternenschilder für maximale Sichtbarkeit. Beidseitig bedruckbar.',
      features: ['Beidseitig bedruckbar', 'Beleuchtbar', 'Wetterfest', 'Klassisches Design'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/54e10ffb8c34f994dece04d2d30cfc5d.jpeg',
      sizes: ['Ø 50cm', 'Ø 60cm', 'Ø 80cm']
    },
    {
      id: 7,
      category: 'schilder',
      name: 'Rechteckiges Schild',
      description: 'Moderne rechteckige Werbeschilder für Fassaden und Eingangsbereiche. Professionelle Optik.',
      features: ['Moderne Optik', 'Verschiedene Materialien', 'Wetterfest', 'Individuelle Größen'],
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/55b06e7aacbe902aa2d698950a45f891.jpeg',
      sizes: ['50 x 70cm', '100 x 70cm', '150 x 100cm']
    }
  ];

  const filteredProducts = selectedCategory === 'alle' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const schema = {
    '@type': 'CollectionPage',
    name: 'Werbemittel & Displays - Professionelle Werbelösungen',
    description: 'Maximale Sichtbarkeit für Ihre Marke: Digitaldrucke, Display-Produkte, Werbeschilder. Von Vinyl-Druck bis Roll-Up Banner.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: products.map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: product.name,
          description: product.description
        }
      }))
    }
  };

  return (
    <>
      <SEO
        title="Werbung - Werbemittel & Display Produkte | Horizon Signage Deutschland"
        description="Maximale Sichtbarkeit für Ihre Marke: Digitaldrucke, Display-Produkte, Werbeschilder. Vinyl-Druck, faltbare Stoffwände, Roll-Up Banner, X-Banner und Laternenschilder. Professionelle Werbelösungen aus einer Hand."
        keywords="Werbemittel, Display, Roll-Up, X-Banner, Digitaldruck, Werbeschilder, Außenwerbung, Deutschland"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/werbung`}
        schema={schema}
      />
      <div className="min-h-screen">
        <Header />
        
        <main className="pt-20">
          {/* Hero Section */}
          <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className="text-center">
                <span className="inline-block px-4 py-2 bg-zinc-800 text-white rounded-full text-sm font-semibold uppercase tracking-wider mb-6">
                  <i className="ri-advertisement-line mr-2"></i>
                  Werbung
                </span>
                <h1 className="text-5xl lg:text-6xl font-bold text-zinc-800 leading-tight mb-6">
                  <span className="block">Professionelle</span>
                  <span className="block text-gray-600">Werbemittel & Displays</span>
                </h1>
                <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                  Maximale Sichtbarkeit für Ihre Marke - von Digitaldrucken über 
                  Display-Produkte bis hin zu Werbeschildern. Alles aus einer Hand.
                </p>
              </div>
            </div>
          </section>

          {/* Category Filter */}
          <section className="py-8 bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className="flex flex-wrap justify-center gap-4">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-zinc-800 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </section>

          {/* Products Grid */}
          <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredProducts.map((product) => (
                  <div
                    key={product.id}
                    className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                    data-product-shop
                  >
                    {/* Product Image */}
                    <div className="aspect-w-4 aspect-h-5">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-64 object-cover object-center"
                      />
                    </div>

                    {/* Product Content */}
                    <div className="p-8">
                      {/* Category Badge */}
                      <div className="mb-4">
                        <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-800 text-xs font-semibold rounded-full uppercase tracking-wider">
                          {categories.find(cat => cat.id === product.category)?.name}
                        </span>
                      </div>

                      {/* Product Name */}
                      <h3 className="text-xl font-bold text-zinc-800 mb-3">
                        {product.name}
                      </h3>

                      {/* Description */}
                      <p className="text-gray-600 mb-4 leading-relaxed">
                        {product.description}
                      </p>

                      {/* Features */}
                      <div className="mb-6">
                        <h4 className="text-sm font-semibold text-zinc-800 mb-2">Eigenschaften:</h4>
                        <ul className="grid grid-cols-2 gap-1 text-sm text-gray-600">
                          {product.features.map((feature, index) => (
                            <li key={index} className="flex items-center">
                              <i className="ri-check-line text-green-500 mr-1 text-xs"></i>
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Sizes */}
                      <div className="mb-6">
                        <h4 className="text-sm font-semibold text-zinc-800 mb-2">Verfügbare Größen:</h4>
                        <div className="flex flex-wrap gap-2">
                          {product.sizes.map((size, index) => (
                            <span key={index} className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                              {size}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* CTA Button */}
                      <a
                        href="/kontakt"
                        className="w-full inline-flex items-center justify-center px-6 py-3 border-2 border-zinc-800 text-zinc-800 font-semibold rounded-lg hover:bg-zinc-800 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                      >
                        Anfrage senden
                        <i className="ri-mail-line ml-2"></i>
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom CTA */}
              <div className="text-center mt-16">
                <div className="bg-white rounded-2xl p-8 max-w-4xl mx-auto shadow-xl">
                  <h3 className="text-2xl font-bold text-zinc-800 mb-4">
                    Individuelles Werbemittel nicht gefunden?
                  </h3>
                  <p className="text-gray-600 text-lg mb-6">
                    Wir fertigen auch maßgeschneiderte Lösungen nach Ihren exakten Vorgaben. 
                    Kontaktieren Sie uns für eine persönliche Beratung.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a
                      href="/kontakt"
                      className="inline-flex items-center justify-center px-8 py-4 bg-zinc-800 text-white font-semibold rounded-lg hover:bg-zinc-900 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Individuelle Anfrage
                      <i className="ri-arrow-right-line ml-2"></i>
                    </a>
                    <a
                      href="tel:+4917296060061"
                      className="inline-flex items-center justify-center px-8 py-4 border-2 border-zinc-800 text-zinc-800 font-semibold rounded-lg hover:bg-zinc-800 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Telefonberatung
                      <i className="ri-phone-line ml-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}
